import { useCallback } from 'react';

import { useFeatureFlagEnabled } from 'posthog-js/react';

import { useMarkExplainerVideoSeen, useUserConfig } from '@/features/user-config';
import { useAppSelector } from '@/hooks/redux-hooks';
import { useStorageValue } from '@/services/storage/react';

export const useExplainerVideoModal = () => {
  const markSeenMutation = useMarkExplainerVideoSeen();
  const isFeatureEnabled = useFeatureFlagEnabled('gxgo-export-video-explainer');
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { data: userConfigData, isSuccess: isConfigLoaded } = useUserConfig();
  const exportVideoExplainerSeen = userConfigData?.exportVideoExplainerSeen;
  const impersonatorEmail = useStorageValue('auth.impersonator');

  const isOpen =
    isFeatureEnabled === true &&
    tripTokenStatus === 'fulfilled' &&
    isConfigLoaded &&
    !impersonatorEmail &&
    !exportVideoExplainerSeen;

  const onDismiss = useCallback(() => {
    markSeenMutation.mutate();
  }, [markSeenMutation]);

  return { isOpen, onDismiss };
};
